import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./invoice.css";

const InvoiceBody = ({ transferData }) => {
  const classes = useStyles();
  // Invoice body

  /// end

  let [transfer, transferSet] = useState([]);
  let [transferDetails, transferDetailsSet] = useState([]);

  useEffect(() => {
    transferSet(transferData);

    if (transferData && transferData.details != undefined) {
      transferDetailsSet(transferData.details);
    } else {
      transferDetailsSet([]);
    }
  }, [transferData]);

  return (
    <>
      <table className={"invoice-table"}>
        <thead>
          <td style={{ textAlign: "left" }}>SL</td>
          <td style={{ textAlign: "left" }}>Category</td>
          <td style={{ textAlign: "left" }}>Product</td>
          <td>Brand</td>
          <td>Country</td>
          <td style={{ textAlign: "left" }}>From Floor</td>
          <td style={{ textAlign: "left" }}>From Rack</td>
          <td style={{ textAlign: "left" }}>To Floor</td>
          <td style={{ textAlign: "left" }}>To Rack</td>
          <td>Qty</td>
          <td>Total</td>
        </thead>
        <tbody>
          {transferDetails.map((detail, ind) => (
            <tr key={detail.transfer_d_id || ind}>
              <td style={{ textAlign: "left" }}>{ind + parseFloat(1)}</td>
              <td style={{ textAlign: "left" }}>{detail.prod_cat_name}</td>
              <td style={{ textAlign: "left" }}>{detail.prod_name}</td>
              <td>{detail.prod_brand_name}</td>
              <td>{detail.prod_color_name}</td>
              <td style={{ textAlign: "left" }}>{detail.from_floor_name}</td>
              <td style={{ textAlign: "left" }}>{detail.from_rack_name}</td>
              <td style={{ textAlign: "left" }}>{detail.to_floor_name}</td>
              <td style={{ textAlign: "left" }}>{detail.to_rack_name}</td>
              <td>{detail.transfer_qty}</td>
              <td style={{ textAlign: "right" }}>
                {parseFloat(detail.transfer_total || 0).toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

const useStyles = makeStyles((theme) => ({}));

export default InvoiceBody;
